// OPEN ALL EXTERNAL LINKS IN NEW TAB
function targetBlank() {
    var internal = location.host.replace("www.", "");
    internal = new RegExp(internal, "i");
    var a = document.getElementsByTagName('a'); // grab every link on the page
    for (var i = 0; i < a.length; i++) {
        var href = a[i].host; // set the host of shopify link
        if( !internal.test(href) ) { // make sure the href of a element in loop doesn't contain current site's host
            a[i].setAttribute('target', '_blank'); // if it doesn't, set attribute
        }
    }
};
// Run the function targetBlank()
targetBlank();


// Relocates the Pickeasy zip-code widget (#zipcode-checker-validator)
// which the app injects before </body>, into the header instead —
// using the #zipcode-slot-desktop / #zipcode-slot-mobile containers
// added to the "Stacked" (design-6) header layout in header.liquid
(function () {
  var BREAKPOINT_QUERY = '(min-width: 1024px)'; // matches the theme's lg breakpoint
  var DESKTOP_SLOT_ID = 'zipcode-slot-desktop';
  var MOBILE_SLOT_ID = 'zipcode-slot-mobile';
  var WIDGET_ID = 'zipcode-checker-validator';
  var INPUT_ID = 'zipcode-checker-box';
  var DESKTOP_PLACEHOLDER = 'Check my zip code';
  var MOBILE_PLACEHOLDER = 'Zip code';

  var mql = window.matchMedia(BREAKPOINT_QUERY);

  function currentSlot() {
    return document.getElementById(mql.matches ? DESKTOP_SLOT_ID : MOBILE_SLOT_ID);
  }

  function setPlaceholder() {
    var input = document.getElementById(INPUT_ID);
    if (!input) return;
    var text = mql.matches ? DESKTOP_PLACEHOLDER : MOBILE_PLACEHOLDER;
    if (input.placeholder !== text) {
      input.placeholder = text;
    }
  }

  function placeWidget() {
    var widget = document.getElementById(WIDGET_ID);
    var slot = currentSlot();
    if (!widget) return;
    setPlaceholder();
    if (!slot) return;
    if (widget.parentElement !== slot) {
      slot.appendChild(widget);
    }
  }

  // Re-place when the viewport crosses the breakpoint (e.g. rotating a tablet).
  if (mql.addEventListener) {
    mql.addEventListener('change', placeWidget);
  } else if (mql.addListener) {
    mql.addListener(placeWidget); // Safari < 14 fallback
  }

  // Watch for Pickeasy injecting (or re-injecting) the widget as a direct
  // child of <body>, and move it into place as soon as it shows up.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        placeWidget();
        break;
      }
    }
  });

  function start() {
    placeWidget(); // in case it's already there
    observer.observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


// REPLACE MEGA MENU COLLECTION LINKS WITH ANCHOR LINKS TO SECTION ON ALL-PRODUCTS PAGE
(function () {
  // Collection handle → new link. Add one line per override.
  var MEGA_MENU_LINK_OVERRIDES = {
    'individual-meals': '/collections/all#individual-meals',
    'family-meals':     '/collections/all#family-meals',
    'soups':            '/collections/all#soups',
    'littles':            '/collections/all#littles',
    'lagniappe':            '/collections/all#lagniappe',
    'something-sweet':            '/collections/all#something-sweet',
    'stock-the-freezer':            '/collections/all#stock-the-freezer',
    'breakfast':            '/collections/all#breakfast-bites',
  };

  var SELECTORS = [
    // Desktop mega menu
    '.f-site-nav__dropdown--mega .collection-card__image-wrapper a',
    '.f-site-nav__dropdown--mega .collection-card__info--group a',
    // Mobile nav drawer
    '.f-mobile-nav__mega-addon--collection .collection-card__image-wrapper a',
    '.f-mobile-nav__mega-addon--collection .collection-card__info--group a'
  ].join(',');

  function applyOverrides() {
    document.querySelectorAll(SELECTORS).forEach(function (link) {
      var match = link.pathname.match(/\/collections\/([^\/]+)\/?$/);
      if (!match) return;

      var handle = decodeURIComponent(match[1]);
      if (MEGA_MENU_LINK_OVERRIDES.hasOwnProperty(handle)) {
        link.setAttribute('href', MEGA_MENU_LINK_OVERRIDES[handle]);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyOverrides);
  } else {
    applyOverrides();
  }
})();


// STYLE THE SHOPIFY FORMS APP
(function() {
  const injectCustomFormStyles = () => {
    // 1. Target the host element from your screenshot
    const shadowHost = document.querySelector('shopify-forms-embed#app-embed');

    if (shadowHost && shadowHost.shadowRoot) {
      // Check if we've already injected the styles to avoid duplicates
      if (shadowHost.shadowRoot.querySelector('.custom-form-styles')) return;

      const style = document.createElement('style');
      style.classList.add('custom-form-styles');
      
      // 2. Add your custom CSS here
      style.textContent = `
        /** Variables **/
        :host {
          --form-background-color: transparent;
          --form-field-border-radius: 0;
          --form-field-border: none; /* box shadow */
          --button-background-color: var(--main-btn-color);
          --button-border-radius: 4px;
          --button-padding: 14px;
        }

        /** Container **/
        section[data-sizing="form-wrapper"] {
          max-width: 768px !important;
          margin: 0 !important;
        }

        /** Submit button **/
        button[class*="formSubmitButton"] {
          font-family: var(--font-btn-family) !important;
          letter-spacing: var(--font-btn-ls) !important;
          text-transform: uppercase !important;
          font-size: var(--font-btn-size) !important;
          font-weight: var(--font-btn-weight) !important;
          width: 122px !important;
          border: 1px solid var(--button-background-color) !important;
          box-sizing: border-box !important;
          position: relative !important;
          isolation: isolate !important;
          overflow: visible !important;
          margin-left: 6px !important;
          transition: .3s !important;
          clear: both;
        }

        /* Button decor - Top & Bottom */
        button[class*="formSubmitButton"]::before {
          content: "";
          position: absolute;
          left: 50%;
          right: 50%;
          translate: -50%;
          top: -5px;
          bottom: -5px;
          background-color: var(--color-btn-bg);
          mask-image:
            url(https://cdn.shopify.com/s/files/1/0839/5184/5611/files/button_shape-top.svg?v=1787601550),
            url(https://cdn.shopify.com/s/files/1/0839/5184/5611/files/button_shape-bottom.svg?v=1787601550);
          mask-repeat: no-repeat, no-repeat;
          mask-position: top, bottom;
          mask-size: 63px 7px, 63px 7px;
          mask-repeat: no-repeat, no-repeat;
          display: block;
          width: 63px;
          transition: .3s;
          pointer-events: none;
      }

        /* Button decor - Left & Right */
        button[class*="formSubmitButton"]::after {
          content: "";
          position: absolute;
          top: 50%;
          translate: 0 -50%;
          left: -5px;
          right: -5px;
          background-color: var(--color-btn-bg);
          mask-image:
            url(https://cdn.shopify.com/s/files/1/0839/5184/5611/files/button_shape-left.svg?v=1787601550),
            url(https://cdn.shopify.com/s/files/1/0839/5184/5611/files/button_shape-right.svg?v=1787601550);
          mask-repeat: no-repeat, no-repeat;
          mask-position: left, right;
          mask-size: 5px 25px, 5px 25px;
          mask-repeat: no-repeat, no-repeat;
          display: block;
          width: calc(100% + 10px);
          height: 25px;
          transition: .3s;
          pointer-events: none;
        }

        /* Button hover */
        button[class*="formSubmitButton"]:hover {
          opacity: 1 !important;
          background: var(--color-tertiary-light) !important;
          color: var(--main-btn-color) !important;
          border-color: var(--color-tertiary-light) !important;
        }

        button[class*="formSubmitButton"]:hover::before,
        button[class*="formSubmitButton"]:hover::after {
          background-color: var(--color-tertiary-light);
        }

        /** Disclaimer text **/
        div[class*="gridItem"] div[class*="formDisclaimer"] {
          text-align: left !important;
          margin: 16px 0 0 !important;
          max-width: 300px;
        }

        div[class*="formDisclaimer"] a {
          color: var(--main-text-color) !important;
          text-decoration: underline;
        }

        /** Labels & input fields **/
        input[class*="formInputField_"] {
          padding-top: 14px !important;
          padding-bottom: 14px !important;
          padding-left: 10px !important;
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
          border: 1px solid var(--color-border) !important;
        }

        input[class*="formInputField_"]:focus-visible {
          box-shadow: none !important;
        }

        label[class*="formInputFieldLabel_"] {
          top: -25px !important;
          left: 0 !important;
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
          letter-spacing: 0 !important;
          font-weight: var(--font-body-weight) !important;
          color: var(--main-text-color) !important;
          transform: none !important;
        }

        div[class*="formFieldContainer_"]:focus-within label[class*="formInputFieldLabel_"] {
          transform: none !important;
        }

        textarea {
          margin-top: 2px;
          padding: 12px !important;
          padding-top: 18px !important;
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
          height: 180px;
          box-sizing: border-box;
          border: 1px solid var(--color-border) !important;
        }

        div[class*="formFieldContainer"]:has(textarea)::before {
          display: none;
        }
        
        div[class*="selectContainer"] p,
        fieldset legend {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
          letter-spacing: 0 !important;
          font-weight: var(--font-body-weight) !important;
          color: var(--main-text-color) !important;
          padding-bottom: 8px !important;
        }

        fieldset label span {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size-sm) !important;
          color: var(--main-text-color) !important;
          margin-left: 12px !important;
        }

        fieldset input {
          width: 18px !important;
          height: 18px !important;
        }

        fieldset {
          margin-bottom: 58px !important;
        }

        fieldset div[class*="horizontalLayout"] {
          grid-template-columns: 1fr 1fr !important;
          row-gap: 16px !important;
        }

        button[class*="selectToggle"] {
          font-family: var(--font-body-family) !important;
          border: 1px solid var(--color-border) !important;
        }

        /* Date fields */
        div[class*="dateFieldContainer"] {
          margin-top: 30px;
        }

        div[class*="birthdayText"] {
          font-size: var(--font-body-size) !important;
          padding-bottom: 0 !important;
        }

        div[class*="dateFieldContainer"] label {
          font-size: var(--font-body-size-sm) !important;
          top: -20px !important;
        }

        /** Success message **/
        section[data-testid="banner-success"] {
          margin-top: 0 !important;
        }
        
        section[data-testid="banner-success"] h2 {
          font-family: var(--font-subheading-family) !important;
          font-size: var(--font-subheading-size) !important;
          font-weight: var(--font-subheading-weight) !important;
          letter-spacing: var(--font-subheading-spacing) !important;
          text-transform: var(--font-subheading-transform) !important;
          padding-bottom: .5rem;
          padding-top: 1rem;
          color: var(--main-heading-color) !important;
        }

        section[data-testid="banner-success"] div[class*="textBody_"] {
          font-family: var(--font-body-family) !important;
          font-size: var(--font-body-size) !important;
          color: var(--main-heading-color) !important;
        }

        @media screen and (max-width: 989px) {
          /* Mobile container padding top */
          div[class*="gridItemContent"] {
            margin-top: 20px !important
          }

          /* Input fields */
          div[class*="formFieldContainer"] {
            margin-bottom: 18px !important;
        }

          input[class*="formInputField_"] {
            margin-bottom: 20px !important;
          }

          div[data-testid="date-birthday"] {
            margin-top: -26px !important;
          }

          /* Select dropdown */
        div[class*="selectContainer"] {
          translate: 0 -28px;
          margin-bottom: 10px;
        }
        }

        @media screen and (min-width: 990px) {
          /* Desktop container padding top */
          div[class*="gridItemContent"] {
            padding-top: 20px !important;
          }

          form[class*="formFieldset"] {
            display: inline-block !important;
            margin-top: 20px;
          }

          /* Labels & input fields */
        div[class*="formFieldContainer"] {
          width: 48%;
          min-width: unset !important;
          float: left;
          box-sizing: border-box;
        }

        div[data-testid="date-birthday"] {
          margin-bottom: 20px !important;
        }

        div[data-testid="date-birthday"] div[class*="formFieldContainer"] {
          width: unset;
        }

        div[class*="dateFieldContainer"],
        button[class*="selectToggle"] {
          width: 70%;
        }

        div[class*="formFieldContainer"]:has(textarea) {
          width: 100%;
          margin-bottom: 30px !important;
          margin-top: 30px;
        }

        div[class*="formFieldContainer"]:has(#first_name),
        div[class*="formFieldContainer"]:has(#email),
        div[class*="formFieldContainer"]:has([id*="guests"]) {
          margin-right: 4% !important;
        }

        input#first_name,
        input#last_name {
          margin-bottom: 50px !important;
        }

        input#email,
        input[id*="phone"] {
          margin-bottom: 20px !important;
        }

        /* Select dropdown */
        div[class*="selectContainer"] {
          margin-bottom: 50px !important;
          clear: both;
        }

        /* Budget & Event type fields */
        div[class*="formFieldContainer"]:has(input[id*="budget"]),
        div[class*="formFieldContainer"]:has(input[id*="event_type"]) {
          clear: both;
          width: 100%;
          margin-top: 50px;
          margin-bottom: 20px;
        }

        div[class*="formFieldContainer"]:has(input[id*="event_type"]) {
          margin-top: 30px;
          margin-bottom: 50px;
        }
        }
      `;

      shadowHost.shadowRoot.appendChild(style);
      console.log('Shopify Form styles injected successfully.');
    }

    // Finds the first textarea found inside the shadow root and adds placeholder text
    const messageField = shadowHost.shadowRoot.querySelector('textarea');
    if (messageField && !messageField.getAttribute('placeholder')) {
      messageField.setAttribute('placeholder', 'Type your message...');
    }

  };

  // Observe the document for when the Shopify Form element is added
  const observer = new MutationObserver((mutations, obs) => {
    const form = document.querySelector('shopify-forms-embed#app-embed');
    if (form) {
      injectCustomFormStyles();
      // Optional: keep observing if the form re-renders, 
      // or disconnect if it's a one-time load
      // obs.disconnect(); 
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();